import { CSSProperties, FC, useState } from 'react'

import {
  IconCheckmark,
  IconChainLink,
  Button,
  Tooltip
} from '@sequencehq/core-components'
import * as Sentry from '@sentry/react'

import { getPortalDomain } from '@sequencehq/utils'

import { getEnvironment } from 'lib/environment/environment'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const ButtonCopyPublishedLink: FC<{
  style?: CSSProperties
  'data-testid'?: string
}> = ({ style, 'data-testid': dataTestId }) => {
  const ctx = useCubeContext()

  const [isCopied, setIsCopied] = useState<boolean>(false)

  const label = isCopied ? 'Link copied' : 'Copy published link'
  const Icon = isCopied ? IconCheckmark : IconChainLink

  const onClick = async () => {
    try {
      const { customerId, id } = ctx.queries.rawData.data.common
      const portalUrl = `${getPortalDomain(getEnvironment())}/quotes/${customerId}/${id}`

      await navigator.clipboard.writeText(portalUrl)

      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 1500)
    } catch (e) {
      Sentry.captureException(e)
    }
  }

  return (
    <Tooltip label={label}>
      <Button
        variant="secondary"
        icon={<Icon color="inherit" />}
        aria-label={label}
        onClick={onClick}
        onBlur={() => setIsCopied(false)}
        style={style}
        data-testid={dataTestId}
      />
    </Tooltip>
  )
}
